module.exports = __webpack_public_path__ + "img/coverTeasing.fe72079b.png";